<template>
  <van-popup
    v-model="kaiguan"
    get-container="body"
    :style="{background:'transparent'}"
    :close-on-click-overlay="false"
    @open="getPrizeList"
  >
    <div class="prize-list">
      <p class="title">我的奖品</p>
      <ul class="lists">
        <li class="item" v-for="(item,idx) in prizeList" :key="idx">
          <p class="goods">{{item.prize}}</p>
          <p class="msg van-ellipsis" v-html="getInfo(item)"></p>
          <p class="time">{{item.mtime}}</p>
          <van-button
            type="info"
            class="btn"
            color="linear-gradient(to bottom, #e28215,#dc580d)"
            v-if="item.status===0"
            @click="handleGetDraw(item)"
          >领取</van-button>
        </li>
      </ul>
    </div>
    <button class="cancel" @click.stop="closePrize"></button>
  </van-popup>
</template>

<script>
export default {
  name: "PrizeList",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    prizeList: []
  }),
  computed: {
    kaiguan: {
      get: function() {
        return this.show;
      },
      set: function() {
        return;
      }
    }
  },
  methods: {
    handleGetDraw(item) {
      this.$parent.open("prizeList");
      this.$emit("handle-get", item);
    },
    closePrize() {
      this.$parent.open("prizeList");
    },
    async getPrizeList() {
      let { data: prizeList } = await this.$api.activity.myPrize();
      if (prizeList.code === 0) {
        let { data } = prizeList;
        data = data.sort((a, b) => new Date(b.mtime) - new Date(a.mtime));
        this.prizeList = Object.freeze(data);
      }
    },
    getInfo(item) {
      if (item.address) {
        let address = item.address
          .split("/")
          .filter(i => i !== "")
          .join("/");
        return address;
      } else if (item.status === 1) {
        return "已领取";
      } else {
        return "未领取";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.prize-list {
  width: 800px;
  padding: 50px;
  background: rgba(255, 255, 255, 1);
  border: 0.1rem solid rgba(255, 255, 255, 1);
  box-shadow: inset 0px 3px 21px 0px rgba(244, 160, 68, 0.78);
  font-size: 45px;
  border-radius: 30px;
  margin-bottom: 80px;
  .title {
    text-align: center;
    margin-bottom: 40px;
  }
  .lists {
    height: 700px;
    overflow-y: scroll;
  }
  .item {
    border-bottom: 1px solid #e1e1e1;
    margin-bottom: 10px;
    position: relative;
  }
  .goods {
    font-size: 40px;
    margin-bottom: 12px;
  }
  .msg {
    font-size: 36px;
    margin-bottom: 14px;
    max-width: 5rem;
  }
  .time {
    font-size: 20px;
    color: #868686;
    margin-bottom: 10px;
  }
  .btn {
    cursor: pointer;
    width: 200px;
    height: 60px;
    line-height: 60px;
    font-size: 30px;
    border-radius: 30px;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
}
.cancel {
  cursor: pointer;
  display: block;
  margin: 0 auto;
  height: 60px;
  width: 60px;
  background: url("../assets/guanbi-min.png") no-repeat;
  background-size: 100% 100%;
}
</style>